import type { TimeAdjustmentRuleSet } from "@/models"
import createCrudEndpoints from "./createCrudEndpoint"

const endpoints = createCrudEndpoints<TimeAdjustmentRuleSet>("/api/rule-sets")

export const listRuleSets = endpoints.list
